import styled from 'styled-components';
import { Modal } from 'react-rainbow-components';
import {
    GREY_300, GREY_700, GREY_800,
} from '../../../../../../constants';

export const StyledModal = styled(Modal)`
    width: 540px;

    > div:first-child {
        padding: 1.5rem 1.5rem 0;
    }
`;

export const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0.25rem 0 0.5rem;
`;

export const FieldRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`;

export const FieldLabel = styled.span`
    font-size: 0.75rem;
    font-weight: 600;
    color: ${GREY_300};
    text-transform: uppercase;
    letter-spacing: 0.04em;
`;

export const FieldValueRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    background: rgba(0, 0, 0, 0.04);
    border-radius: 8px;
    padding: 0.625rem 0.75rem;
`;

export const FieldValue = styled.span`
    font-size: 0.875rem;
    font-weight: 500;
    color: ${GREY_700};
    word-break: break-all;
    flex: 1;
`;

export const PasswordHint = styled.p`
    margin: 0;
    font-size: 0.75rem;
    font-style: italic;
    color: ${GREY_300};
    text-align: center;
`;

export const ModalFooter = styled.div`
    display: flex;
    justify-content: center;
    padding: 1rem 1.5rem 1.5rem;
`;

export const ModalHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;
`;

export const HeaderTitle = styled.h2`
    margin: 0;
    font-size: 1.125rem;
    font-weight: 700;
    color: ${GREY_800};
`;
